/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OEX API
 * Operators Exchange REST API (docs/08). Org-scoped routes take the active organisation in X-Org-Id; errors are RFC 7807 problem details with a `code`.
 * OpenAPI spec version: 1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AddEmailParticipantDto,
  AddParticipantsDto,
  BlockDto,
  BlockListDto,
  CreateBlockDto,
  CreateThreadDto,
  EditMessageDto,
  EmailParticipantDto,
  EmailParticipantListDto,
  MarkReadDto,
  MessageDto,
  MessageListDto,
  MessagingAdminListThreadsParams,
  MessagingListMessagesParams,
  MessagingListRecipientsParams,
  MessagingListThreadsParams,
  MessagingUnreadCountDto,
  MuteThreadDto,
  RecipientListDto,
  SendMessageDto,
  ThreadAdminListDto,
  ThreadDto,
  ThreadListDto,
  UnsubscribeResultDto,
  WebhookAckDto
} from '../../model';

import { oexFetch } from '../../../fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getMessagingAdminListThreadsUrl = (params?: MessagingAdminListThreadsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/admin/threads?${stringifiedParams}` : `/v1/admin/threads`
}

/**
 * @summary Thread metadata across the network (participant orgs, counts); no bodies
 */
export const messagingAdminListThreads = async (params?: MessagingAdminListThreadsParams, options?: Parameters<typeof oexFetch>[1]): Promise<ThreadAdminListDto> => {

  return oexFetch<ThreadAdminListDto>(getMessagingAdminListThreadsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMessagingAdminListThreadsQueryKey = (params?: MessagingAdminListThreadsParams,) => {
    return [
    `/v1/admin/threads`, ...(params ? [params] : [])
    ] as const;
    }


export const getMessagingAdminListThreadsQueryOptions = <TData = Awaited<ReturnType<typeof messagingAdminListThreads>>, TError = unknown>(params?: MessagingAdminListThreadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingAdminListThreads>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMessagingAdminListThreadsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof messagingAdminListThreads>>> = ({ signal }) => messagingAdminListThreads(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof messagingAdminListThreads>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MessagingAdminListThreadsQueryResult = NonNullable<Awaited<ReturnType<typeof messagingAdminListThreads>>>
export type MessagingAdminListThreadsQueryError = unknown


export function useMessagingAdminListThreads<TData = Awaited<ReturnType<typeof messagingAdminListThreads>>, TError = unknown>(
 params: undefined |  MessagingAdminListThreadsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingAdminListThreads>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof messagingAdminListThreads>>,
          TError,
          Awaited<ReturnType<typeof messagingAdminListThreads>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessagingAdminListThreads<TData = Awaited<ReturnType<typeof messagingAdminListThreads>>, TError = unknown>(
 params?: MessagingAdminListThreadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingAdminListThreads>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof messagingAdminListThreads>>,
          TError,
          Awaited<ReturnType<typeof messagingAdminListThreads>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessagingAdminListThreads<TData = Awaited<ReturnType<typeof messagingAdminListThreads>>, TError = unknown>(
 params?: MessagingAdminListThreadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingAdminListThreads>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Thread metadata across the network (participant orgs, counts); no bodies
 */

export function useMessagingAdminListThreads<TData = Awaited<ReturnType<typeof messagingAdminListThreads>>, TError = unknown>(
 params?: MessagingAdminListThreadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingAdminListThreads>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMessagingAdminListThreadsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMessagingListBlocksUrl = () => {




  return `/v1/blocks`
}

/**
 * @summary People I blocked
 */
export const messagingListBlocks = async ( options?: Parameters<typeof oexFetch>[1]): Promise<BlockListDto> => {

  return oexFetch<BlockListDto>(getMessagingListBlocksUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMessagingListBlocksQueryKey = () => {
    return [
    `/v1/blocks`
    ] as const;
    }


export const getMessagingListBlocksQueryOptions = <TData = Awaited<ReturnType<typeof messagingListBlocks>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingListBlocks>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMessagingListBlocksQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof messagingListBlocks>>> = ({ signal }) => messagingListBlocks({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof messagingListBlocks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MessagingListBlocksQueryResult = NonNullable<Awaited<ReturnType<typeof messagingListBlocks>>>
export type MessagingListBlocksQueryError = unknown


export function useMessagingListBlocks<TData = Awaited<ReturnType<typeof messagingListBlocks>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingListBlocks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof messagingListBlocks>>,
          TError,
          Awaited<ReturnType<typeof messagingListBlocks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessagingListBlocks<TData = Awaited<ReturnType<typeof messagingListBlocks>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingListBlocks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof messagingListBlocks>>,
          TError,
          Awaited<ReturnType<typeof messagingListBlocks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessagingListBlocks<TData = Awaited<ReturnType<typeof messagingListBlocks>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingListBlocks>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary People I blocked
 */

export function useMessagingListBlocks<TData = Awaited<ReturnType<typeof messagingListBlocks>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingListBlocks>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMessagingListBlocksQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMessagingCreateBlockUrl = () => {




  return `/v1/blocks`
}

/**
 * @summary Block a person (dm refused; hidden in groups)
 */
export const messagingCreateBlock = async (createBlockDto: CreateBlockDto, options?: Parameters<typeof oexFetch>[1]): Promise<BlockDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return oexFetch<BlockDto>(getMessagingCreateBlockUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createBlockDto)
  }
);}





export const getMessagingCreateBlockMutationKey = () => ['messagingCreateBlock'] as const;

export const getMessagingCreateBlockMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingCreateBlock>>, TError,MessagingCreateBlockMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof messagingCreateBlock>>, TError,MessagingCreateBlockMutationVariables, TContext> => {

const mutationKey = getMessagingCreateBlockMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof messagingCreateBlock>>, MessagingCreateBlockMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  messagingCreateBlock(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MessagingCreateBlockMutationResult = NonNullable<Awaited<ReturnType<typeof messagingCreateBlock>>>
    export type MessagingCreateBlockMutationBody = CreateBlockDto
    export type MessagingCreateBlockMutationError = unknown
    export type MessagingCreateBlockMutationVariables = {data: CreateBlockDto}

    /**
 * @summary Block a person (dm refused; hidden in groups)
 */
export const useMessagingCreateBlock = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingCreateBlock>>, TError,MessagingCreateBlockMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof messagingCreateBlock>>,
        TError,
        MessagingCreateBlockMutationVariables,
        TContext
      > => {
      return useMutation(getMessagingCreateBlockMutationOptions(options), queryClient);
    }
    export const getMessagingDeleteBlockUrl = (blockedUserId: string,) => {




  return `/v1/blocks/${blockedUserId}`
}

/**
 * @summary Unblock
 */
export const messagingDeleteBlock = async (blockedUserId: string, options?: Parameters<typeof oexFetch>[1]): Promise<void> => {

  return oexFetch<void>(getMessagingDeleteBlockUrl(blockedUserId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getMessagingDeleteBlockMutationKey = () => ['messagingDeleteBlock'] as const;

export const getMessagingDeleteBlockMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingDeleteBlock>>, TError,MessagingDeleteBlockMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof messagingDeleteBlock>>, TError,MessagingDeleteBlockMutationVariables, TContext> => {

const mutationKey = getMessagingDeleteBlockMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof messagingDeleteBlock>>, MessagingDeleteBlockMutationVariables> = (props) => {
          const {blockedUserId} = props ?? {};

          return  messagingDeleteBlock(blockedUserId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MessagingDeleteBlockMutationResult = NonNullable<Awaited<ReturnType<typeof messagingDeleteBlock>>>

    export type MessagingDeleteBlockMutationError = unknown
    export type MessagingDeleteBlockMutationVariables = {blockedUserId: string}

    /**
 * @summary Unblock
 */
export const useMessagingDeleteBlock = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingDeleteBlock>>, TError,MessagingDeleteBlockMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof messagingDeleteBlock>>,
        TError,
        MessagingDeleteBlockMutationVariables,
        TContext
      > => {
      return useMutation(getMessagingDeleteBlockMutationOptions(options), queryClient);
    }
    export const getMessagingUnsubscribePageUrl = (token: string,) => {




  return `/v1/public/messaging/unsubscribe/${token}`
}

/**
 * @summary Confirmation page of an unsubscribe link (text/html, no side effect)
 */
export const messagingUnsubscribePage = async (token: string, options?: Parameters<typeof oexFetch>[1]): Promise<void> => {

  return oexFetch<void>(getMessagingUnsubscribePageUrl(token),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMessagingUnsubscribePageQueryKey = (token: string,) => {
    return [
    `/v1/public/messaging/unsubscribe/${token}`
    ] as const;
    }


export const getMessagingUnsubscribePageQueryOptions = <TData = Awaited<ReturnType<typeof messagingUnsubscribePage>>, TError = unknown>(token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingUnsubscribePage>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMessagingUnsubscribePageQueryKey(token);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof messagingUnsubscribePage>>> = ({ signal }) => messagingUnsubscribePage(token, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: token !== null && token !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof messagingUnsubscribePage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MessagingUnsubscribePageQueryResult = NonNullable<Awaited<ReturnType<typeof messagingUnsubscribePage>>>
export type MessagingUnsubscribePageQueryError = unknown


export function useMessagingUnsubscribePage<TData = Awaited<ReturnType<typeof messagingUnsubscribePage>>, TError = unknown>(
 token: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingUnsubscribePage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof messagingUnsubscribePage>>,
          TError,
          Awaited<ReturnType<typeof messagingUnsubscribePage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessagingUnsubscribePage<TData = Awaited<ReturnType<typeof messagingUnsubscribePage>>, TError = unknown>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingUnsubscribePage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof messagingUnsubscribePage>>,
          TError,
          Awaited<ReturnType<typeof messagingUnsubscribePage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessagingUnsubscribePage<TData = Awaited<ReturnType<typeof messagingUnsubscribePage>>, TError = unknown>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingUnsubscribePage>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Confirmation page of an unsubscribe link (text/html, no side effect)
 */

export function useMessagingUnsubscribePage<TData = Awaited<ReturnType<typeof messagingUnsubscribePage>>, TError = unknown>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingUnsubscribePage>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMessagingUnsubscribePageQueryOptions(token,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMessagingUnsubscribeUrl = (token: string,) => {




  return `/v1/public/messaging/unsubscribe/${token}`
}

/**
 * @summary Unsubscribe an external participant (one-click)
 */
export const messagingUnsubscribe = async (token: string, options?: Parameters<typeof oexFetch>[1]): Promise<UnsubscribeResultDto> => {

  return oexFetch<UnsubscribeResultDto>(getMessagingUnsubscribeUrl(token),
  {
    ...options,
    method: 'POST'


  }
);}





export const getMessagingUnsubscribeMutationKey = () => ['messagingUnsubscribe'] as const;

export const getMessagingUnsubscribeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingUnsubscribe>>, TError,MessagingUnsubscribeMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof messagingUnsubscribe>>, TError,MessagingUnsubscribeMutationVariables, TContext> => {

const mutationKey = getMessagingUnsubscribeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof messagingUnsubscribe>>, MessagingUnsubscribeMutationVariables> = (props) => {
          const {token} = props ?? {};

          return  messagingUnsubscribe(token,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MessagingUnsubscribeMutationResult = NonNullable<Awaited<ReturnType<typeof messagingUnsubscribe>>>

    export type MessagingUnsubscribeMutationError = unknown
    export type MessagingUnsubscribeMutationVariables = {token: string}

    /**
 * @summary Unsubscribe an external participant (one-click)
 */
export const useMessagingUnsubscribe = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingUnsubscribe>>, TError,MessagingUnsubscribeMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof messagingUnsubscribe>>,
        TError,
        MessagingUnsubscribeMutationVariables,
        TContext
      > => {
      return useMutation(getMessagingUnsubscribeMutationOptions(options), queryClient);
    }
    export const getMessagingListThreadsUrl = (params?: MessagingListThreadsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/threads?${stringifiedParams}` : `/v1/threads`
}

/**
 * @summary My threads, newest activity first, with unread counts
 */
export const messagingListThreads = async (params?: MessagingListThreadsParams, options?: Parameters<typeof oexFetch>[1]): Promise<ThreadListDto> => {

  return oexFetch<ThreadListDto>(getMessagingListThreadsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMessagingListThreadsQueryKey = (params?: MessagingListThreadsParams,) => {
    return [
    `/v1/threads`, ...(params ? [params] : [])
    ] as const;
    }


export const getMessagingListThreadsQueryOptions = <TData = Awaited<ReturnType<typeof messagingListThreads>>, TError = unknown>(params?: MessagingListThreadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingListThreads>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMessagingListThreadsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof messagingListThreads>>> = ({ signal }) => messagingListThreads(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof messagingListThreads>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MessagingListThreadsQueryResult = NonNullable<Awaited<ReturnType<typeof messagingListThreads>>>
export type MessagingListThreadsQueryError = unknown


export function useMessagingListThreads<TData = Awaited<ReturnType<typeof messagingListThreads>>, TError = unknown>(
 params: undefined |  MessagingListThreadsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingListThreads>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof messagingListThreads>>,
          TError,
          Awaited<ReturnType<typeof messagingListThreads>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessagingListThreads<TData = Awaited<ReturnType<typeof messagingListThreads>>, TError = unknown>(
 params?: MessagingListThreadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingListThreads>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof messagingListThreads>>,
          TError,
          Awaited<ReturnType<typeof messagingListThreads>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessagingListThreads<TData = Awaited<ReturnType<typeof messagingListThreads>>, TError = unknown>(
 params?: MessagingListThreadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingListThreads>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary My threads, newest activity first, with unread counts
 */

export function useMessagingListThreads<TData = Awaited<ReturnType<typeof messagingListThreads>>, TError = unknown>(
 params?: MessagingListThreadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingListThreads>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMessagingListThreadsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMessagingCreateThreadUrl = () => {




  return `/v1/threads`
}

/**
 * @summary Create a dm (returns the existing one for the pair) or a group of 2-7; 402 messaging.connected, 422 not_connected | blocked | too_many_recipients | too_few_recipients, 429
 */
export const messagingCreateThread = async (createThreadDto: CreateThreadDto, options?: Parameters<typeof oexFetch>[1]): Promise<ThreadDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return oexFetch<ThreadDto>(getMessagingCreateThreadUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createThreadDto)
  }
);}





export const getMessagingCreateThreadMutationKey = () => ['messagingCreateThread'] as const;

export const getMessagingCreateThreadMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingCreateThread>>, TError,MessagingCreateThreadMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof messagingCreateThread>>, TError,MessagingCreateThreadMutationVariables, TContext> => {

const mutationKey = getMessagingCreateThreadMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof messagingCreateThread>>, MessagingCreateThreadMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  messagingCreateThread(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MessagingCreateThreadMutationResult = NonNullable<Awaited<ReturnType<typeof messagingCreateThread>>>
    export type MessagingCreateThreadMutationBody = CreateThreadDto
    export type MessagingCreateThreadMutationError = unknown
    export type MessagingCreateThreadMutationVariables = {data: CreateThreadDto}

    /**
 * @summary Create a dm (returns the existing one for the pair) or a group of 2-7; 402 messaging.connected, 422 not_connected | blocked | too_many_recipients | too_few_recipients, 429
 */
export const useMessagingCreateThread = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingCreateThread>>, TError,MessagingCreateThreadMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof messagingCreateThread>>,
        TError,
        MessagingCreateThreadMutationVariables,
        TContext
      > => {
      return useMutation(getMessagingCreateThreadMutationOptions(options), queryClient);
    }
    export const getMessagingGetThreadUrl = (id: string,) => {




  return `/v1/threads/${id}`
}

/**
 * @summary One thread I take part in
 */
export const messagingGetThread = async (id: string, options?: Parameters<typeof oexFetch>[1]): Promise<ThreadDto> => {

  return oexFetch<ThreadDto>(getMessagingGetThreadUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMessagingGetThreadQueryKey = (id: string,) => {
    return [
    `/v1/threads/${id}`
    ] as const;
    }


export const getMessagingGetThreadQueryOptions = <TData = Awaited<ReturnType<typeof messagingGetThread>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingGetThread>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMessagingGetThreadQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof messagingGetThread>>> = ({ signal }) => messagingGetThread(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof messagingGetThread>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MessagingGetThreadQueryResult = NonNullable<Awaited<ReturnType<typeof messagingGetThread>>>
export type MessagingGetThreadQueryError = unknown


export function useMessagingGetThread<TData = Awaited<ReturnType<typeof messagingGetThread>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingGetThread>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof messagingGetThread>>,
          TError,
          Awaited<ReturnType<typeof messagingGetThread>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessagingGetThread<TData = Awaited<ReturnType<typeof messagingGetThread>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingGetThread>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof messagingGetThread>>,
          TError,
          Awaited<ReturnType<typeof messagingGetThread>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessagingGetThread<TData = Awaited<ReturnType<typeof messagingGetThread>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingGetThread>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One thread I take part in
 */

export function useMessagingGetThread<TData = Awaited<ReturnType<typeof messagingGetThread>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingGetThread>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMessagingGetThreadQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMessagingArchiveThreadUrl = (id: string,) => {




  return `/v1/threads/${id}/archive`
}

/**
 * @summary Archive a group (owner)
 */
export const messagingArchiveThread = async (id: string, options?: Parameters<typeof oexFetch>[1]): Promise<ThreadDto> => {

  return oexFetch<ThreadDto>(getMessagingArchiveThreadUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getMessagingArchiveThreadMutationKey = () => ['messagingArchiveThread'] as const;

export const getMessagingArchiveThreadMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingArchiveThread>>, TError,MessagingArchiveThreadMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof messagingArchiveThread>>, TError,MessagingArchiveThreadMutationVariables, TContext> => {

const mutationKey = getMessagingArchiveThreadMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof messagingArchiveThread>>, MessagingArchiveThreadMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  messagingArchiveThread(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MessagingArchiveThreadMutationResult = NonNullable<Awaited<ReturnType<typeof messagingArchiveThread>>>

    export type MessagingArchiveThreadMutationError = unknown
    export type MessagingArchiveThreadMutationVariables = {id: string}

    /**
 * @summary Archive a group (owner)
 */
export const useMessagingArchiveThread = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingArchiveThread>>, TError,MessagingArchiveThreadMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof messagingArchiveThread>>,
        TError,
        MessagingArchiveThreadMutationVariables,
        TContext
      > => {
      return useMutation(getMessagingArchiveThreadMutationOptions(options), queryClient);
    }
    export const getMessagingDownloadAttachmentUrl = (id: string,
    fileId: string,) => {




  return `/v1/threads/${id}/attachments/${fileId}`
}

/**
 * @summary Redirect to a short-lived signed download URL
 */
export const messagingDownloadAttachment = async (id: string,
    fileId: string, options?: Parameters<typeof oexFetch>[1]): Promise<unknown> => {

  return oexFetch<unknown>(getMessagingDownloadAttachmentUrl(id,fileId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMessagingDownloadAttachmentQueryKey = (id: string,
    fileId: string,) => {
    return [
    `/v1/threads/${id}/attachments/${fileId}`
    ] as const;
    }


export const getMessagingDownloadAttachmentQueryOptions = <TData = Awaited<ReturnType<typeof messagingDownloadAttachment>>, TError = void>(id: string,
    fileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingDownloadAttachment>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMessagingDownloadAttachmentQueryKey(id,fileId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof messagingDownloadAttachment>>> = ({ signal }) => messagingDownloadAttachment(id,fileId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && fileId !== null && fileId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof messagingDownloadAttachment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MessagingDownloadAttachmentQueryResult = NonNullable<Awaited<ReturnType<typeof messagingDownloadAttachment>>>
export type MessagingDownloadAttachmentQueryError = void


export function useMessagingDownloadAttachment<TData = Awaited<ReturnType<typeof messagingDownloadAttachment>>, TError = void>(
 id: string,
    fileId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingDownloadAttachment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof messagingDownloadAttachment>>,
          TError,
          Awaited<ReturnType<typeof messagingDownloadAttachment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessagingDownloadAttachment<TData = Awaited<ReturnType<typeof messagingDownloadAttachment>>, TError = void>(
 id: string,
    fileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingDownloadAttachment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof messagingDownloadAttachment>>,
          TError,
          Awaited<ReturnType<typeof messagingDownloadAttachment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessagingDownloadAttachment<TData = Awaited<ReturnType<typeof messagingDownloadAttachment>>, TError = void>(
 id: string,
    fileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingDownloadAttachment>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Redirect to a short-lived signed download URL
 */

export function useMessagingDownloadAttachment<TData = Awaited<ReturnType<typeof messagingDownloadAttachment>>, TError = void>(
 id: string,
    fileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingDownloadAttachment>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMessagingDownloadAttachmentQueryOptions(id,fileId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMessagingListEmailParticipantsUrl = (id: string,) => {




  return `/v1/threads/${id}/email-participants`
}

/**
 * @summary External email-only participants
 */
export const messagingListEmailParticipants = async (id: string, options?: Parameters<typeof oexFetch>[1]): Promise<EmailParticipantListDto> => {

  return oexFetch<EmailParticipantListDto>(getMessagingListEmailParticipantsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMessagingListEmailParticipantsQueryKey = (id: string,) => {
    return [
    `/v1/threads/${id}/email-participants`
    ] as const;
    }


export const getMessagingListEmailParticipantsQueryOptions = <TData = Awaited<ReturnType<typeof messagingListEmailParticipants>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingListEmailParticipants>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMessagingListEmailParticipantsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof messagingListEmailParticipants>>> = ({ signal }) => messagingListEmailParticipants(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof messagingListEmailParticipants>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MessagingListEmailParticipantsQueryResult = NonNullable<Awaited<ReturnType<typeof messagingListEmailParticipants>>>
export type MessagingListEmailParticipantsQueryError = unknown


export function useMessagingListEmailParticipants<TData = Awaited<ReturnType<typeof messagingListEmailParticipants>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingListEmailParticipants>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof messagingListEmailParticipants>>,
          TError,
          Awaited<ReturnType<typeof messagingListEmailParticipants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessagingListEmailParticipants<TData = Awaited<ReturnType<typeof messagingListEmailParticipants>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingListEmailParticipants>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof messagingListEmailParticipants>>,
          TError,
          Awaited<ReturnType<typeof messagingListEmailParticipants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessagingListEmailParticipants<TData = Awaited<ReturnType<typeof messagingListEmailParticipants>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingListEmailParticipants>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary External email-only participants
 */

export function useMessagingListEmailParticipants<TData = Awaited<ReturnType<typeof messagingListEmailParticipants>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingListEmailParticipants>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMessagingListEmailParticipantsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMessagingAddEmailParticipantUrl = (id: string,) => {




  return `/v1/threads/${id}/email-participants`
}

/**
 * @summary Invite an external address by email (thread owner, or any participant of a context thread); 402 messaging.external_email (plan or daily limit), 409 DUPLICATE, 422 email_suppressed
 */
export const messagingAddEmailParticipant = async (id: string,
    addEmailParticipantDto: AddEmailParticipantDto, options?: Parameters<typeof oexFetch>[1]): Promise<EmailParticipantDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return oexFetch<EmailParticipantDto>(getMessagingAddEmailParticipantUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(addEmailParticipantDto)
  }
);}





export const getMessagingAddEmailParticipantMutationKey = () => ['messagingAddEmailParticipant'] as const;

export const getMessagingAddEmailParticipantMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingAddEmailParticipant>>, TError,MessagingAddEmailParticipantMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof messagingAddEmailParticipant>>, TError,MessagingAddEmailParticipantMutationVariables, TContext> => {

const mutationKey = getMessagingAddEmailParticipantMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof messagingAddEmailParticipant>>, MessagingAddEmailParticipantMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  messagingAddEmailParticipant(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MessagingAddEmailParticipantMutationResult = NonNullable<Awaited<ReturnType<typeof messagingAddEmailParticipant>>>
    export type MessagingAddEmailParticipantMutationBody = AddEmailParticipantDto
    export type MessagingAddEmailParticipantMutationError = unknown
    export type MessagingAddEmailParticipantMutationVariables = {id: string;data: AddEmailParticipantDto}

    /**
 * @summary Invite an external address by email (thread owner, or any participant of a context thread); 402 messaging.external_email (plan or daily limit), 409 DUPLICATE, 422 email_suppressed
 */
export const useMessagingAddEmailParticipant = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingAddEmailParticipant>>, TError,MessagingAddEmailParticipantMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof messagingAddEmailParticipant>>,
        TError,
        MessagingAddEmailParticipantMutationVariables,
        TContext
      > => {
      return useMutation(getMessagingAddEmailParticipantMutationOptions(options), queryClient);
    }
    export const getMessagingRemoveEmailParticipantUrl = (id: string,
    emailParticipantId: string,) => {




  return `/v1/threads/${id}/email-participants/${emailParticipantId}`
}

/**
 * @summary Stop emailing an external participant (tokens revoked)
 */
export const messagingRemoveEmailParticipant = async (id: string,
    emailParticipantId: string, options?: Parameters<typeof oexFetch>[1]): Promise<void> => {

  return oexFetch<void>(getMessagingRemoveEmailParticipantUrl(id,emailParticipantId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getMessagingRemoveEmailParticipantMutationKey = () => ['messagingRemoveEmailParticipant'] as const;

export const getMessagingRemoveEmailParticipantMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingRemoveEmailParticipant>>, TError,MessagingRemoveEmailParticipantMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof messagingRemoveEmailParticipant>>, TError,MessagingRemoveEmailParticipantMutationVariables, TContext> => {

const mutationKey = getMessagingRemoveEmailParticipantMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof messagingRemoveEmailParticipant>>, MessagingRemoveEmailParticipantMutationVariables> = (props) => {
          const {id,emailParticipantId} = props ?? {};

          return  messagingRemoveEmailParticipant(id,emailParticipantId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MessagingRemoveEmailParticipantMutationResult = NonNullable<Awaited<ReturnType<typeof messagingRemoveEmailParticipant>>>

    export type MessagingRemoveEmailParticipantMutationError = unknown
    export type MessagingRemoveEmailParticipantMutationVariables = {id: string;emailParticipantId: string}

    /**
 * @summary Stop emailing an external participant (tokens revoked)
 */
export const useMessagingRemoveEmailParticipant = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingRemoveEmailParticipant>>, TError,MessagingRemoveEmailParticipantMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof messagingRemoveEmailParticipant>>,
        TError,
        MessagingRemoveEmailParticipantMutationVariables,
        TContext
      > => {
      return useMutation(getMessagingRemoveEmailParticipantMutationOptions(options), queryClient);
    }
    export const getMessagingListMessagesUrl = (id: string,
    params?: MessagingListMessagesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/threads/${id}/messages?${stringifiedParams}` : `/v1/threads/${id}/messages`
}

/**
 * @summary Messages oldest → newest; `before` pages back, `after` fetches newer
 */
export const messagingListMessages = async (id: string,
    params?: MessagingListMessagesParams, options?: Parameters<typeof oexFetch>[1]): Promise<MessageListDto> => {

  return oexFetch<MessageListDto>(getMessagingListMessagesUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMessagingListMessagesQueryKey = (id: string,
    params?: MessagingListMessagesParams,) => {
    return [
    `/v1/threads/${id}/messages`, ...(params ? [params] : [])
    ] as const;
    }


export const getMessagingListMessagesQueryOptions = <TData = Awaited<ReturnType<typeof messagingListMessages>>, TError = unknown>(id: string,
    params?: MessagingListMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingListMessages>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMessagingListMessagesQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof messagingListMessages>>> = ({ signal }) => messagingListMessages(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof messagingListMessages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MessagingListMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof messagingListMessages>>>
export type MessagingListMessagesQueryError = unknown


export function useMessagingListMessages<TData = Awaited<ReturnType<typeof messagingListMessages>>, TError = unknown>(
 id: string,
    params: undefined |  MessagingListMessagesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingListMessages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof messagingListMessages>>,
          TError,
          Awaited<ReturnType<typeof messagingListMessages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessagingListMessages<TData = Awaited<ReturnType<typeof messagingListMessages>>, TError = unknown>(
 id: string,
    params?: MessagingListMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingListMessages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof messagingListMessages>>,
          TError,
          Awaited<ReturnType<typeof messagingListMessages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessagingListMessages<TData = Awaited<ReturnType<typeof messagingListMessages>>, TError = unknown>(
 id: string,
    params?: MessagingListMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingListMessages>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Messages oldest → newest; `before` pages back, `after` fetches newer
 */

export function useMessagingListMessages<TData = Awaited<ReturnType<typeof messagingListMessages>>, TError = unknown>(
 id: string,
    params?: MessagingListMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingListMessages>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMessagingListMessagesQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMessagingSendMessageUrl = (id: string,) => {




  return `/v1/threads/${id}/messages`
}

/**
 * @summary Send (dedupe on clientMessageId for 24 h); 422 thread_archived | blocked | not_connected, 429
 */
export const messagingSendMessage = async (id: string,
    sendMessageDto: SendMessageDto, options?: Parameters<typeof oexFetch>[1]): Promise<MessageDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return oexFetch<MessageDto>(getMessagingSendMessageUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(sendMessageDto)
  }
);}





export const getMessagingSendMessageMutationKey = () => ['messagingSendMessage'] as const;

export const getMessagingSendMessageMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingSendMessage>>, TError,MessagingSendMessageMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof messagingSendMessage>>, TError,MessagingSendMessageMutationVariables, TContext> => {

const mutationKey = getMessagingSendMessageMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof messagingSendMessage>>, MessagingSendMessageMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  messagingSendMessage(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MessagingSendMessageMutationResult = NonNullable<Awaited<ReturnType<typeof messagingSendMessage>>>
    export type MessagingSendMessageMutationBody = SendMessageDto
    export type MessagingSendMessageMutationError = unknown
    export type MessagingSendMessageMutationVariables = {id: string;data: SendMessageDto}

    /**
 * @summary Send (dedupe on clientMessageId for 24 h); 422 thread_archived | blocked | not_connected, 429
 */
export const useMessagingSendMessage = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingSendMessage>>, TError,MessagingSendMessageMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof messagingSendMessage>>,
        TError,
        MessagingSendMessageMutationVariables,
        TContext
      > => {
      return useMutation(getMessagingSendMessageMutationOptions(options), queryClient);
    }
    export const getMessagingEditMessageUrl = (id: string,
    messageId: string,) => {




  return `/v1/threads/${id}/messages/${messageId}`
}

/**
 * @summary Edit my message within 15 minutes
 */
export const messagingEditMessage = async (id: string,
    messageId: string,
    editMessageDto: EditMessageDto, options?: Parameters<typeof oexFetch>[1]): Promise<MessageDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return oexFetch<MessageDto>(getMessagingEditMessageUrl(id,messageId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(editMessageDto)
  }
);}





export const getMessagingEditMessageMutationKey = () => ['messagingEditMessage'] as const;

export const getMessagingEditMessageMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingEditMessage>>, TError,MessagingEditMessageMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof messagingEditMessage>>, TError,MessagingEditMessageMutationVariables, TContext> => {

const mutationKey = getMessagingEditMessageMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof messagingEditMessage>>, MessagingEditMessageMutationVariables> = (props) => {
          const {id,messageId,data} = props ?? {};

          return  messagingEditMessage(id,messageId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MessagingEditMessageMutationResult = NonNullable<Awaited<ReturnType<typeof messagingEditMessage>>>
    export type MessagingEditMessageMutationBody = EditMessageDto
    export type MessagingEditMessageMutationError = unknown
    export type MessagingEditMessageMutationVariables = {id: string;messageId: string;data: EditMessageDto}

    /**
 * @summary Edit my message within 15 minutes
 */
export const useMessagingEditMessage = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingEditMessage>>, TError,MessagingEditMessageMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof messagingEditMessage>>,
        TError,
        MessagingEditMessageMutationVariables,
        TContext
      > => {
      return useMutation(getMessagingEditMessageMutationOptions(options), queryClient);
    }
    export const getMessagingDeleteMessageUrl = (id: string,
    messageId: string,) => {




  return `/v1/threads/${id}/messages/${messageId}`
}

/**
 * @summary Soft delete (body cleared, attachments detached)
 */
export const messagingDeleteMessage = async (id: string,
    messageId: string, options?: Parameters<typeof oexFetch>[1]): Promise<MessageDto> => {

  return oexFetch<MessageDto>(getMessagingDeleteMessageUrl(id,messageId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getMessagingDeleteMessageMutationKey = () => ['messagingDeleteMessage'] as const;

export const getMessagingDeleteMessageMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingDeleteMessage>>, TError,MessagingDeleteMessageMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof messagingDeleteMessage>>, TError,MessagingDeleteMessageMutationVariables, TContext> => {

const mutationKey = getMessagingDeleteMessageMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof messagingDeleteMessage>>, MessagingDeleteMessageMutationVariables> = (props) => {
          const {id,messageId} = props ?? {};

          return  messagingDeleteMessage(id,messageId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MessagingDeleteMessageMutationResult = NonNullable<Awaited<ReturnType<typeof messagingDeleteMessage>>>

    export type MessagingDeleteMessageMutationError = unknown
    export type MessagingDeleteMessageMutationVariables = {id: string;messageId: string}

    /**
 * @summary Soft delete (body cleared, attachments detached)
 */
export const useMessagingDeleteMessage = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingDeleteMessage>>, TError,MessagingDeleteMessageMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof messagingDeleteMessage>>,
        TError,
        MessagingDeleteMessageMutationVariables,
        TContext
      > => {
      return useMutation(getMessagingDeleteMessageMutationOptions(options), queryClient);
    }
    export const getMessagingMuteThreadUrl = (id: string,) => {




  return `/v1/threads/${id}/mute`
}

/**
 * @summary Mute until a time (omitted: indefinitely; null: unmute)
 */
export const messagingMuteThread = async (id: string,
    muteThreadDto: MuteThreadDto, options?: Parameters<typeof oexFetch>[1]): Promise<ThreadDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return oexFetch<ThreadDto>(getMessagingMuteThreadUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(muteThreadDto)
  }
);}





export const getMessagingMuteThreadMutationKey = () => ['messagingMuteThread'] as const;

export const getMessagingMuteThreadMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingMuteThread>>, TError,MessagingMuteThreadMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof messagingMuteThread>>, TError,MessagingMuteThreadMutationVariables, TContext> => {

const mutationKey = getMessagingMuteThreadMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof messagingMuteThread>>, MessagingMuteThreadMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  messagingMuteThread(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MessagingMuteThreadMutationResult = NonNullable<Awaited<ReturnType<typeof messagingMuteThread>>>
    export type MessagingMuteThreadMutationBody = MuteThreadDto
    export type MessagingMuteThreadMutationError = unknown
    export type MessagingMuteThreadMutationVariables = {id: string;data: MuteThreadDto}

    /**
 * @summary Mute until a time (omitted: indefinitely; null: unmute)
 */
export const useMessagingMuteThread = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingMuteThread>>, TError,MessagingMuteThreadMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof messagingMuteThread>>,
        TError,
        MessagingMuteThreadMutationVariables,
        TContext
      > => {
      return useMutation(getMessagingMuteThreadMutationOptions(options), queryClient);
    }
    export const getMessagingAddParticipantsUrl = (id: string,) => {




  return `/v1/threads/${id}/participants`
}

/**
 * @summary Add people to a group (eligibility re-checked)
 */
export const messagingAddParticipants = async (id: string,
    addParticipantsDto: AddParticipantsDto, options?: Parameters<typeof oexFetch>[1]): Promise<ThreadDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return oexFetch<ThreadDto>(getMessagingAddParticipantsUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(addParticipantsDto)
  }
);}





export const getMessagingAddParticipantsMutationKey = () => ['messagingAddParticipants'] as const;

export const getMessagingAddParticipantsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingAddParticipants>>, TError,MessagingAddParticipantsMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof messagingAddParticipants>>, TError,MessagingAddParticipantsMutationVariables, TContext> => {

const mutationKey = getMessagingAddParticipantsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof messagingAddParticipants>>, MessagingAddParticipantsMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  messagingAddParticipants(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MessagingAddParticipantsMutationResult = NonNullable<Awaited<ReturnType<typeof messagingAddParticipants>>>
    export type MessagingAddParticipantsMutationBody = AddParticipantsDto
    export type MessagingAddParticipantsMutationError = unknown
    export type MessagingAddParticipantsMutationVariables = {id: string;data: AddParticipantsDto}

    /**
 * @summary Add people to a group (eligibility re-checked)
 */
export const useMessagingAddParticipants = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingAddParticipants>>, TError,MessagingAddParticipantsMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof messagingAddParticipants>>,
        TError,
        MessagingAddParticipantsMutationVariables,
        TContext
      > => {
      return useMutation(getMessagingAddParticipantsMutationOptions(options), queryClient);
    }
    export const getMessagingRemoveParticipantUrl = (id: string,
    userId: string,) => {




  return `/v1/threads/${id}/participants/${userId}`
}

/**
 * @summary Group owner removes a participant
 */
export const messagingRemoveParticipant = async (id: string,
    userId: string, options?: Parameters<typeof oexFetch>[1]): Promise<ThreadDto> => {

  return oexFetch<ThreadDto>(getMessagingRemoveParticipantUrl(id,userId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getMessagingRemoveParticipantMutationKey = () => ['messagingRemoveParticipant'] as const;

export const getMessagingRemoveParticipantMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingRemoveParticipant>>, TError,MessagingRemoveParticipantMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof messagingRemoveParticipant>>, TError,MessagingRemoveParticipantMutationVariables, TContext> => {

const mutationKey = getMessagingRemoveParticipantMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof messagingRemoveParticipant>>, MessagingRemoveParticipantMutationVariables> = (props) => {
          const {id,userId} = props ?? {};

          return  messagingRemoveParticipant(id,userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MessagingRemoveParticipantMutationResult = NonNullable<Awaited<ReturnType<typeof messagingRemoveParticipant>>>

    export type MessagingRemoveParticipantMutationError = unknown
    export type MessagingRemoveParticipantMutationVariables = {id: string;userId: string}

    /**
 * @summary Group owner removes a participant
 */
export const useMessagingRemoveParticipant = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingRemoveParticipant>>, TError,MessagingRemoveParticipantMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof messagingRemoveParticipant>>,
        TError,
        MessagingRemoveParticipantMutationVariables,
        TContext
      > => {
      return useMutation(getMessagingRemoveParticipantMutationOptions(options), queryClient);
    }
    export const getMessagingLeaveThreadUrl = (id: string,) => {




  return `/v1/threads/${id}/participants/me`
}

/**
 * @summary Leave a group
 */
export const messagingLeaveThread = async (id: string, options?: Parameters<typeof oexFetch>[1]): Promise<void> => {

  return oexFetch<void>(getMessagingLeaveThreadUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getMessagingLeaveThreadMutationKey = () => ['messagingLeaveThread'] as const;

export const getMessagingLeaveThreadMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingLeaveThread>>, TError,MessagingLeaveThreadMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof messagingLeaveThread>>, TError,MessagingLeaveThreadMutationVariables, TContext> => {

const mutationKey = getMessagingLeaveThreadMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof messagingLeaveThread>>, MessagingLeaveThreadMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  messagingLeaveThread(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MessagingLeaveThreadMutationResult = NonNullable<Awaited<ReturnType<typeof messagingLeaveThread>>>

    export type MessagingLeaveThreadMutationError = unknown
    export type MessagingLeaveThreadMutationVariables = {id: string}

    /**
 * @summary Leave a group
 */
export const useMessagingLeaveThread = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingLeaveThread>>, TError,MessagingLeaveThreadMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof messagingLeaveThread>>,
        TError,
        MessagingLeaveThreadMutationVariables,
        TContext
      > => {
      return useMutation(getMessagingLeaveThreadMutationOptions(options), queryClient);
    }
    export const getMessagingMarkReadUrl = (id: string,) => {




  return `/v1/threads/${id}/read`
}

/**
 * @summary Move my read marker forward; pushes unread totals over SSE
 */
export const messagingMarkRead = async (id: string,
    markReadDto: MarkReadDto, options?: Parameters<typeof oexFetch>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return oexFetch<void>(getMessagingMarkReadUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(markReadDto)
  }
);}





export const getMessagingMarkReadMutationKey = () => ['messagingMarkRead'] as const;

export const getMessagingMarkReadMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingMarkRead>>, TError,MessagingMarkReadMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof messagingMarkRead>>, TError,MessagingMarkReadMutationVariables, TContext> => {

const mutationKey = getMessagingMarkReadMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof messagingMarkRead>>, MessagingMarkReadMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  messagingMarkRead(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MessagingMarkReadMutationResult = NonNullable<Awaited<ReturnType<typeof messagingMarkRead>>>
    export type MessagingMarkReadMutationBody = MarkReadDto
    export type MessagingMarkReadMutationError = unknown
    export type MessagingMarkReadMutationVariables = {id: string;data: MarkReadDto}

    /**
 * @summary Move my read marker forward; pushes unread totals over SSE
 */
export const useMessagingMarkRead = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingMarkRead>>, TError,MessagingMarkReadMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof messagingMarkRead>>,
        TError,
        MessagingMarkReadMutationVariables,
        TContext
      > => {
      return useMutation(getMessagingMarkReadMutationOptions(options), queryClient);
    }
    export const getMessagingUnarchiveThreadUrl = (id: string,) => {




  return `/v1/threads/${id}/unarchive`
}

/**
 * @summary Reopen a group the owner archived
 */
export const messagingUnarchiveThread = async (id: string, options?: Parameters<typeof oexFetch>[1]): Promise<ThreadDto> => {

  return oexFetch<ThreadDto>(getMessagingUnarchiveThreadUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getMessagingUnarchiveThreadMutationKey = () => ['messagingUnarchiveThread'] as const;

export const getMessagingUnarchiveThreadMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingUnarchiveThread>>, TError,MessagingUnarchiveThreadMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof messagingUnarchiveThread>>, TError,MessagingUnarchiveThreadMutationVariables, TContext> => {

const mutationKey = getMessagingUnarchiveThreadMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof messagingUnarchiveThread>>, MessagingUnarchiveThreadMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  messagingUnarchiveThread(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MessagingUnarchiveThreadMutationResult = NonNullable<Awaited<ReturnType<typeof messagingUnarchiveThread>>>

    export type MessagingUnarchiveThreadMutationError = unknown
    export type MessagingUnarchiveThreadMutationVariables = {id: string}

    /**
 * @summary Reopen a group the owner archived
 */
export const useMessagingUnarchiveThread = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingUnarchiveThread>>, TError,MessagingUnarchiveThreadMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof messagingUnarchiveThread>>,
        TError,
        MessagingUnarchiveThreadMutationVariables,
        TContext
      > => {
      return useMutation(getMessagingUnarchiveThreadMutationOptions(options), queryClient);
    }
    export const getMessagingListRecipientsUrl = (params?: MessagingListRecipientsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/threads/recipients?${stringifiedParams}` : `/v1/threads/recipients`
}

/**
 * @summary People I can message: colleagues, then members of connected companies
 */
export const messagingListRecipients = async (params?: MessagingListRecipientsParams, options?: Parameters<typeof oexFetch>[1]): Promise<RecipientListDto> => {

  return oexFetch<RecipientListDto>(getMessagingListRecipientsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMessagingListRecipientsQueryKey = (params?: MessagingListRecipientsParams,) => {
    return [
    `/v1/threads/recipients`, ...(params ? [params] : [])
    ] as const;
    }


export const getMessagingListRecipientsQueryOptions = <TData = Awaited<ReturnType<typeof messagingListRecipients>>, TError = unknown>(params?: MessagingListRecipientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingListRecipients>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMessagingListRecipientsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof messagingListRecipients>>> = ({ signal }) => messagingListRecipients(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof messagingListRecipients>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MessagingListRecipientsQueryResult = NonNullable<Awaited<ReturnType<typeof messagingListRecipients>>>
export type MessagingListRecipientsQueryError = unknown


export function useMessagingListRecipients<TData = Awaited<ReturnType<typeof messagingListRecipients>>, TError = unknown>(
 params: undefined |  MessagingListRecipientsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingListRecipients>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof messagingListRecipients>>,
          TError,
          Awaited<ReturnType<typeof messagingListRecipients>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessagingListRecipients<TData = Awaited<ReturnType<typeof messagingListRecipients>>, TError = unknown>(
 params?: MessagingListRecipientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingListRecipients>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof messagingListRecipients>>,
          TError,
          Awaited<ReturnType<typeof messagingListRecipients>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessagingListRecipients<TData = Awaited<ReturnType<typeof messagingListRecipients>>, TError = unknown>(
 params?: MessagingListRecipientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingListRecipients>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary People I can message: colleagues, then members of connected companies
 */

export function useMessagingListRecipients<TData = Awaited<ReturnType<typeof messagingListRecipients>>, TError = unknown>(
 params?: MessagingListRecipientsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingListRecipients>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMessagingListRecipientsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMessagingUnreadCountUrl = () => {




  return `/v1/threads/unread-count`
}

/**
 * @summary Unread messages: total and per thread
 */
export const messagingUnreadCount = async ( options?: Parameters<typeof oexFetch>[1]): Promise<MessagingUnreadCountDto> => {

  return oexFetch<MessagingUnreadCountDto>(getMessagingUnreadCountUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMessagingUnreadCountQueryKey = () => {
    return [
    `/v1/threads/unread-count`
    ] as const;
    }


export const getMessagingUnreadCountQueryOptions = <TData = Awaited<ReturnType<typeof messagingUnreadCount>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingUnreadCount>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMessagingUnreadCountQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof messagingUnreadCount>>> = ({ signal }) => messagingUnreadCount({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof messagingUnreadCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MessagingUnreadCountQueryResult = NonNullable<Awaited<ReturnType<typeof messagingUnreadCount>>>
export type MessagingUnreadCountQueryError = unknown


export function useMessagingUnreadCount<TData = Awaited<ReturnType<typeof messagingUnreadCount>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingUnreadCount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof messagingUnreadCount>>,
          TError,
          Awaited<ReturnType<typeof messagingUnreadCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessagingUnreadCount<TData = Awaited<ReturnType<typeof messagingUnreadCount>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingUnreadCount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof messagingUnreadCount>>,
          TError,
          Awaited<ReturnType<typeof messagingUnreadCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMessagingUnreadCount<TData = Awaited<ReturnType<typeof messagingUnreadCount>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingUnreadCount>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Unread messages: total and per thread
 */

export function useMessagingUnreadCount<TData = Awaited<ReturnType<typeof messagingUnreadCount>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof messagingUnreadCount>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMessagingUnreadCountQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMessagingReceiveResendInboundUrl = () => {




  return `/v1/webhooks/resend-inbound`
}

/**
 * @summary Resend inbound (email.received) and delivery problems of thread emails; Svix-signed; stored and processed in the worker
 */
export const messagingReceiveResendInbound = async ( options?: Parameters<typeof oexFetch>[1]): Promise<WebhookAckDto> => {

  return oexFetch<WebhookAckDto>(getMessagingReceiveResendInboundUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getMessagingReceiveResendInboundMutationKey = () => ['messagingReceiveResendInbound'] as const;

export const getMessagingReceiveResendInboundMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingReceiveResendInbound>>, TError,void, TContext>, request?: SecondParameter<typeof oexFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof messagingReceiveResendInbound>>, TError,void, TContext> => {

const mutationKey = getMessagingReceiveResendInboundMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof messagingReceiveResendInbound>>, void> = () => {


          return  messagingReceiveResendInbound(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MessagingReceiveResendInboundMutationResult = NonNullable<Awaited<ReturnType<typeof messagingReceiveResendInbound>>>

    export type MessagingReceiveResendInboundMutationError = unknown


    /**
 * @summary Resend inbound (email.received) and delivery problems of thread emails; Svix-signed; stored and processed in the worker
 */
export const useMessagingReceiveResendInbound = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingReceiveResendInbound>>, TError,void, TContext>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof messagingReceiveResendInbound>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getMessagingReceiveResendInboundMutationOptions(options), queryClient);
    }
